import './less/autocomplete.less';
import 'devbridge-autocomplete';

const autocomplete = props => {
	
	let globalSearchSelector = '#global-search-input';
	let acProps = {
		selector: globalSearchSelector,
		serviceUrl: 'autocomplete,20.html',
		minChars: 3,
		paramName: 'q',
		appendTo: $(globalSearchSelector).parent(),
		onSelect: function (suggestion) {
			window.location.href = suggestion.data;
		},
		formatResult: function (suggestion, currentValue) {
			return '<table><tr><td class="ac-image"><span><img src="' + suggestion.image + '" class="img-responsive"></span></td><td class="name">' + suggestion.value + '</td></tr></table>';
		}
	};
	
	let defaults = {
		...acProps,
		...props
	};
	
	const init = () => {
		$(defaults.selector).autocomplete(defaults);
	};

	init();
};

export default autocomplete;


// WEBPACK FOOTER //
// ../components/autocomplete/autocomplete.js